import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content" style={{ overflowY: "inherit" }}>
                <section className="wide-tb-100 p-0 bg-sky-blue home-welcome">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-4">
                                <a href="service-details.html">
                                    <div className="icon-box-with-img bg-secondary">
                                        <img src="images/icon-box-img-1.jpg" alt="" />
                                        <div className="text">
                                            Freight Forwarding
                </div>
                                    </div>
                                </a>
                            </div>

                            <div className="col-md-4">
                                <a href="service-details.html">
                                    <div className="icon-box-with-img bg-secondary">
                                        <img src="images/icon-box-img-2.jpg" alt="" />
                                        <div className="text">
                                            Road Freight
                </div>
                                    </div>
                                </a>
                            </div>

                            <div className="col-md-4">
                                <a href="service-details.html">
                                    <div className="icon-box-with-img bg-secondary">
                                        <img src="images/icon-box-img-3.jpg" alt="" />
                                        <div className="text">
                                            Car transportation
                </div>
                                    </div>
                                </a>
                            </div>

                        </div>
                    </div>
                </section>

                <section className="bg-sky-blue wide-tb-100">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="img-business-man">
                                <img src="images/courier-man.png" alt="" />
                            </div>
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>Our Goodness</span>
                                    What Makes Us Special
            </h1>
                            </div>
                            <div className="col-md-6 ml-auto">
                                <div className="row">
                                    <div className="col-12 wow fadeInUp" data-wow-duration="0" data-wow-delay="0s">
                                        <div className="icon-box-3 mb-5 bg-sky-blue">
                                            <div className="media">
                                                <div className="service-icon mr-5">
                                                    <i className="icofont-box"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Packaging and Storage</h4>
                                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae. Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                        <div className="icon-box-3 mb-5 bg-sky-blue">
                                            <div className="media">
                                                <div className="service-icon mr-5">
                                                    <i className="icofont-shield"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Safety & Quality</h4>
                                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae. Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.4s">
                                        <div className="icon-box-3 bg-sky-blue">
                                            <div className="media">
                                                <div className="service-icon mr-5">
                                                    <i className="icofont-tree-alt"></i>
                                                </div>
                                                <div className="service-inner-content media-body">
                                                    <h4 className="h4-md">Care for Environment</h4>
                                                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae. Praesent pellentesque diam vitae nibh aliquam faucibus.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <section className="bg-white wide-tb-100 mb-spacer-md">
                    <div className="container">
                        <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                            <h1 className="heading-main">
                                <span>Who we are</span>
                                About Us
          </h1>
                        </div>

                        <div className="row wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                            <div className="col-lg-8">
                                <div className="about-bg bg-sky-blue">
                                    <div className="row d-flex align-items-end">
                                        <div className="col-12 pt-5 order-sm-12 col-sm-6">
                                            <blockquote className="blockquote style-one">
                                                <p className="mb-0">There is no design without discipline. There is no discipline without intelligence.</p>
                                                <footer className="blockquote-footer"><cite title="Source Title">Steven Snell Google</cite></footer>
                                            </blockquote>
                                        </div>
                                        <div className="col-12 mb-0 order-sm-1 col-sm-6">
                                            <img src="images/about_img.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>

                            <div className="col-lg-4">
                                <div className="align-self-stretch h-100 align-items-center d-flex bg-with-text">
                                    Whether you require distribution or fulfillment, defined freight forwarding, or a complete supply chain solution, we are here for you.
              </div>
                            </div>
                        </div>


                        <div className="row text-center mobile-100">
                            <div className="col-sm-12">
                                <div className="spacer-50"></div>
                                <a href="#" className="btn-theme bg-primary">Request Quote <i className="icofont-rounded-right"></i></a>
                                <a href="#" className="ml-5 link-oragne icon-left play-video"><i className="icofont-play"></i> Watch Our Short Video</a>
                            </div>
                            <div className="video-box">
                                <div className="close-video">
                                    <i className="fa fa-times"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-scroll counter-bg pos-rel">
                    <div className="bg-overlay blue opacity-50"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0s">
                                <p><i className="icofont-google-map"></i></p>
                                <span className="counter">15</span>
                                <div>
                                    Our Locations
              </div>
                            </div>

                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0s">
                                <p><i className="icofont-globe"></i></p>
                                <span className="counter">110</span>
                                <span>+</span>
                                <div>
                                    Clients Worldwide
              </div>
                            </div>

                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>

                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight" data-wow-duration="0" data-wow-delay="0">
                                <p><i className="icofont-vehicle-delivery-van"></i></p>
                                <span className="counter">240</span>
                                <span>+</span>
                                <div>
                                    Owned Vehicles
                                </div>
                            </div>

                            <div className="col counter-style-1 col-6 col-lg-3 col-sm-6 wow fadeInRight" data-wow-duration="0" data-wow-delay="0s">
                                <p><i className="icofont-umbrella-alt"></i></p>
                                <span className="counter">2340</span>
                                <div>
                                    Tonnes Transported
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 ml-lg-auto pos-rel col-md-12">

                                <h1 className="heading-main text-left">
                                    <span>get updates</span>
                                    Tracking Your Freight
                                </h1>

                                <form className="form-inline tracking">
                                    <input type="text" className="form-control mb-2 mr-sm-2 col" placeholder="Enter order number" />
                                    <button type="submit" className="btn btn-theme bg-primary mb-2 ml-3">Check Now <i className="icofont-rounded-right"></i></button>
                                </form>

                                <div className="forklift-image wow slideInLeft" data-wow-duration="0" data-wow-delay="0s">
                                    <img src="images/forklift_Image.png" alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-white wide-tb-100 mb-spacer-md">
                    <div className="container">
                        <div className="col-sm-12">
                            <h1 className="heading-main">
                                <span>Face Behind Logzee</span>
                                Our Team
                            </h1>
                        </div>

                        <div className="row pb-5">
                            <div className="col-12 col-lg-3 col-sm-6 wow fadeInUp" data-wow-duration="0" data-wow-delay="0s">
                                <div className="team-section-one">
                                    <img src="images/team/team-1.jpg" alt="" className="rounded-circle" />
                                    <h4 className="h4-md txt-blue">John Morise</h4>
                                    <h5 className="h5-md txt-ligt-gray">Founder</h5>
                                </div>
                            </div>

                            <div className="col-12 col-lg-3 col-sm-6 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="team-section-one">
                                    <img src="images/team/team-2.jpg" alt="" className="rounded-circle" />
                                    <h4 className="h4-md txt-blue">Kevin Mash</h4>
                                    <h5 className="h5-md txt-ligt-gray">Head Operational</h5>
                                </div>
                            </div>

                            <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>

                            <div className="col-12 col-lg-3 col-sm-6 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="team-section-one">
                                    <img src="images/team/team-3.jpg" alt="" className="rounded-circle" />
                                    <h4 className="h4-md txt-blue">Mike Douglos</h4>
                                    <h5 className="h5-md txt-ligt-gray">Team Lead Support</h5>
                                </div>
                            </div>

                            <div className="col-12 col-lg-3 col-sm-6 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.3s">
                                <div className="team-section-one">
                                    <img src="images/team/team-4.jpg" alt="" className="rounded-circle" />
                                    <h4 className="h4-md txt-blue">Jeff Fashkin</h4>
                                    <h5 className="h5-md txt-ligt-gray">Head Operational</h5>
                                </div>
                            </div>
                        </div>

                        <div className="row text-center mt-5 wow fadeInDown" data-wow-duration="0" data-wow-delay="0.5s">
                            <div className="col-sm-8 offset-md-2">
                                <h3 className="h3-xl fw-7 txt-blue">We Are Hiring! <span className="lead fw-5 txt-ligt-gray">Become part of our talented team</span></h3>
                                <p className="mt-4">Vivamus imperdiet pulvinar risus, at posuere justo scelerisque sed. Vestibulum ante
            ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.</p>
                                <a href="#" className="btn-theme bg-secondary mt-2">Join Our Team <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-fixed free-quote free-quote-alt pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-7">
                                <div className="free-quote-form">
                                    <h1 className="heading-main mb-4">
                                        <span>Request a </span>
                                        Free Quote
                                    </h1>

                                    <form action="#" method="post" noValidate="novalidate" className="col rounded-field">
                                        <div className="form-row mb-4">
                                            <input type="text" name="name" className="form-control" placeholder="Your Name" />
                                        </div>
                                        <div className="form-row mb-4">
                                            <input type="text" name="email" className="form-control" placeholder="Email" />
                                        </div>
                                        <div className="form-row mb-4">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Transport Type</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="form-row mb-4">
                                            <select title="Please choose a package" required="" name="package" className="custom-select" aria-required="true" aria-invalid="false">
                                                <option value="">Type of freight</option>
                                                <option value="Type 1">Type 1</option>
                                                <option value="Type 2">Type 2</option>
                                                <option value="Type 3">Type 3</option>
                                                <option value="Type 4">Type 4</option>
                                            </select>
                                        </div>
                                        <div className="form-row mb-4">
                                            <textarea rows="7" placeholder="Message" className="form-control"></textarea>
                                        </div>
                                        <div className="form-row text-center">
                                            <button type="submit" className="form-btn mx-auto btn-theme bg-secondary">Submit Now <i className="icofont-rounded-right"></i></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>What Our</span>
                                    Customers Saying
                                </h1>
                            </div>
                            <div className="col-sm-12">
                                <div className="owl-carousel owl-theme" id="home-client-testimonials">

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_1.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_2.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="client-testimonial bg-wave">
                                            <div className="media">
                                                <div className="client-testimonial-icon rounded-circle bg-primary">
                                                    <img src="images/team_3.jpg" alt="" />
                                                </div>
                                                <div className="client-inner-content media-body">
                                                    <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Aliquam gravida, urna quis ornare imperdiet, </p>
                                                    <footer className="blockquote-footer"><cite title="Source Title">John Gerry  Design Hunt</cite></footer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-80 bg-primary callout-style-1 wow fadeInUp" data-wow-duration="0" data-wow-delay="0s">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
                                </div>
                            </div>
                            <div className="col-sm-auto">
                                <a href="#" className="btn-theme bg-white light">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="wide-tb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>COMPANY'S NEWS</span>
                                    Recent Posts
                                </h1>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInLeft" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_1.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_2.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4 wow fadeInRight" data-wow-duration="0" data-wow-delay="0.1s">
                                <div className="blog-warp">
                                    <img src="images/blog_img_3.jpg" alt="" className="rounded" />
                                    <div className="meta-box"><a href="#">Business</a> <span>/</span>    September 28, 2018</div>
                                    <h4 className="h4-md mb-3"><a href="#">Freight Payment and Auditing Services</a></h4>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantiumg</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <section className="wide-tb-100 bg-fixed clients-bg pos-rel">
                    <div className="bg-overlay blue opacity-80"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>SOME OF OUR</span>
                                    Clients
                                </h1>
                            </div>

                            <div className="col-sm-12 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="owl-carousel owl-theme" id="home-clients">

                                    <div className="item">
                                        <img src="images/clients/client1.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client2.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client3.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client4.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client5.png" alt="" />
                                    </div>

                                    <div className="item">
                                        <img src="images/clients/client6.png" alt="" />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="map-bg">
                    <div className="contact-details row d-flex">
                        <div className="col">
                            <h4>Germany</h4>
                            <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                            <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">germany@logzee.com</a></div>
                        </div>
                        <div className="col">
                            <h4>Spain</h4>
                            <p><i className="icofont-phone"></i> +1 (408) 786 - 5117</p>
                            <div className="text-nowrap"><i className="icofont-email"></i> <a href="#">spain@logzee.com</a></div>
                        </div>
                    </div>
                    <div id="map-holder" className="pos-rel">
                        <div id="map_extended">
                            <p>This will be replaced with the Google Map.</p>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};
export default Content;
